import { render, staticRenderFns } from "./UiImageCardDetails.vue?vue&type=template&id=1e298eec&scoped=true&"
import script from "./UiImageCardDetails.vue?vue&type=script&lang=ts&"
export * from "./UiImageCardDetails.vue?vue&type=script&lang=ts&"
import style0 from "./UiImageCardDetails.vue?vue&type=style&index=0&id=1e298eec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e298eec",
  null
  
)

export default component.exports